
import React from 'react';
import SettingsNavigation from '@/components/settings/navigation';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import SettingsContent from './SettingsContent';
import { SettingSection } from '@/hooks/useSettingsState';

interface SettingsLayoutProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  editing: Record<string, boolean>;
  handleEditToggle: (section: SettingSection) => void;
  handleSave: (section: SettingSection) => void;
}

const SettingsLayout = ({ 
  activeTab, 
  setActiveTab, 
  editing, 
  handleEditToggle, 
  handleSave 
}: SettingsLayoutProps) => {
  return (
    <div className="container mx-auto px-4 py-4 sm:py-6 space-y-6 sm:space-y-8">
      <SettingsBreadcrumb activeTab={activeTab} />
      
      <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 settings-content">
        <div className="w-full sm:w-64 sm:flex-shrink-0">
          <SettingsNavigation activeTab={activeTab} onChange={setActiveTab} />
        </div>
        
        <SettingsContent 
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          editing={editing}
          handleEditToggle={handleEditToggle}
          handleSave={handleSave}
        />
      </div>
    </div>
  );
};

export default SettingsLayout;
